var map = {
	"./big@2x.png": "7895",
	"./dragon1@2x.png": "54ba",
	"./goldFront@2x.png": "9215",
	"./gold_db@2x.png": "5900",
	"./gold_ii@2x.png": "50a3",
	"./gold_inte@2x.png": "8c55",
	"./gold_ll@2x.png": "00f8",
	"./gold_lv@2x.png": "74e8",
	"./gold_plus@2x.png": "9a92",
	"./gold_prime@2x.png": "baf8",
	"./hands@2x.png": "bce1",
	"./world@2x.png": "3955"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f19";